import 'normalize.css';
import './common/css/main.css';
import './common/css/base-fonts.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Route } from 'react-router';
import { Home } from './pages/home/Home';
import { BrandedClientShareLayout } from './layouts/branded-client-share/BrandedClientShare';


const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <div>
      {/* <Route exact path='/' component={Home} /> */}
      <Route exact path='/(en|fr)/passive-investment-income' component={BrandedClientShareLayout} />
    </div>
  </BrowserRouter>,
  rootElement);